var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldText',{attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength,"state":_vm.state,"prefix":_vm.prefix,"suffix":_vm.suffix,"disabled":_vm.disabled,"is-required":_vm.isRequired,"class-wrapper":"my-field-number"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})
}
var staticRenderFns = []

export { render, staticRenderFns }